import { FunctionComponent } from "react";
import * as React from "react";
import { useSportsbookBetslipContext } from "../../context/sportsbook";
import { useExchangeBetslipContext } from "../../context/exchange";
import type { BetslipLocalization, Jurisdiction } from "../../contract";

function renderInJurisdiction<T>(
  WrappedComponent: FunctionComponent<T>,
  localization: BetslipLocalization,
  jurisdictions: Jurisdiction[],
  props: T,
): React.ReactElement<T> | null {
  const { jurisdiction } = localization;

  if (jurisdiction && jurisdictions.includes(jurisdiction)) {
    return <WrappedComponent {...(props as React.PropsWithChildren<T>)} />;
  }

  return null;
}

export function withSportsbookJurisdiction<T>(
  WrappedComponent: FunctionComponent<T>,
  { jurisdictions }: { jurisdictions: Jurisdiction[] },
): (props: T) => React.ReactElement<T> | null {
  return function SportsbookJurisdictionalGuard(props: T) {
    const { localization } = useSportsbookBetslipContext();

    return renderInJurisdiction(WrappedComponent, localization, jurisdictions, props);
  };
}

export function withExchangeJurisdiction<T>(
  WrappedComponent: FunctionComponent<T>,
  { jurisdictions }: { jurisdictions: Jurisdiction[] },
): (props: T) => React.ReactElement<T> | null {
  return function ExchangeJurisdictionalGuard(props: T) {
    const { localization } = useExchangeBetslipContext();

    return renderInJurisdiction(WrappedComponent, localization, jurisdictions, props);
  };
}
